import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppStore } from '../store/useAppStore';
import { isStaffRole } from '../types/roles';

type Props = { children: ReactNode };

/**
 * Requires Supabase session and `public.users.role` of admin or superadmin.
 * Regular members are redirected to the library.
 */
export function RequireStaff({ children }: Props) {
  const session = useAppStore((s) => s.session);
  const userRole = useAppStore((s) => s.userRole);
  const location = useLocation();

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (!isStaffRole(userRole)) {
    return <Navigate to="/library" replace />;
  }

  return <>{children}</>;
}
